import { render, staticRenderFns } from "./DataProviderOverlay.vue?vue&type=template&id=2564d1cf&scoped=true&"
import script from "./DataProviderOverlay.vue?vue&type=script&lang=ts&"
export * from "./DataProviderOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./DataProviderOverlay.vue?vue&type=style&index=0&id=2564d1cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564d1cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VOverlay,VRow,VSpacer})
